<template>
    <al-button
        variant="primary"
        @click="showModal = true"
        :disabled="!state.isDirty"
        class="save-button"
    >
        <al-icon
            icon="save"
            class="save-icon"
            variant="secondary"
        />
        <span class="button-text">
            Save Configuration
        </span>
    </al-button>
    <Teleport to="body">
        <Modal
            :show="showModal"
            @close="showModal = false"
        >
            <template #body>
                <p>By saving your configuration, you will be applying the changes across the system.</p>
                <p>Are you sure you want to execute the changes you've made?</p>
            </template>
            <template #footer>
                <al-button
                    variant="secondary"
                    @click="showModal = false"
                    class="modal-button"
                >
                    Cancel
                </al-button>
                <al-button
                    variant="primary"
                    @click="saveConfiguration"
                    class="modal-button"
                >
                    Yes, save configuration
                </al-button>
            </template>
        </Modal>
    </Teleport>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { state } from '@/utils/state';
import Modal from '@agyletime/vue-3-common/src/components/Modal/TeleportModal.vue';
import { Toast } from '@/types';
import _, { cloneDeep } from 'lodash';
import { lambda } from '@/utils/postToLambda';

const showModal = ref(false);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function saveConfiguration() {
    showModal.value = false;

    // await lambda.post('/performance-metrics/saved-configuration', JSON.stringify(state.categories));
    await lambda.put('/performance-metrics/definitions', JSON.stringify(state.dirtyMetrics));

    state.savedCategories = cloneDeep(state.categories);
    state.isDirty = false;

    const newToast: Toast = {
        message: 'Saved',
        id: _.uniqueId()
    };
    state.toasts.push(newToast);
}
</script>
<style lang="scss">
    .title-row {
        .al2-button {
            margin-top: 4px;
            padding: 0px 10px 0px 10px;
            font-size: 12.8px;
            margin-bottom: 8px;
        }
    }
</style>